<p>{{ numberOfRows }} {{ numberOfRows != 1 ? 'rows' : 'row' }}</p>
<button mat-flat-button color="primary" (click)="exportData()">Export CSV</button>
